'use strict';

import React, { Component } from 'react'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'

import Modal  from '@Modal/Modal'

import FormElement from '@/Form/toolkit/FormElement'

import getFormStatus from '@/Form/Functions/getFormStatus'

import { handleChange } from '@/Form/Functions/eventsHandling'

import { isTrue, safeNumeral } from '@root/utility'

import bemit from '@function/bemit'

import _ from 'lodash'

const { app, qwest, numeral, moment } = window;

moment.locale('fr');

numeral.locale('en');

export default class CartModal extends Component
{
	state =
	{
		open: false,
		form_data: { online_ticket: false },
		status_messages: { }
	};

	handleChange = handleChange.bind(this);

	componentDidMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			event: 'open__CartModal',
			cb: component.open,
			source: ''
		});

		component.setState(
		{
			status_messages: { },
			nominative_info: true,
			form_data: { online_ticket: false },
			product: { cart_price: { } },
			open: false
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'open__CartModal',
			cb: component.open
		});
	}

	handleOnlineShippingChange = (e, data) =>
	{
		const props = this.props, component = this, state = this.state;

		let product = _.cloneDeep(state.product);

		component.handleChange(e, data);

		product.cart_onlineTicket = data.value;

		component.setState(
		{
			product: product
		});
	}

	handleOrderAsChange = (e) =>
	{
		const props = this.props, component = this, state = this.state;

		state.product.EC_order_as = e.target.value;

		component.setState(
		{
			product: state.product
		});
	}

	handleRequiredDateChange = (e, data) =>
	{
		const props = this.props, component = this, state = this.state;

		state.product.date_required_value = data.value;

		component.setState(
		{
			product: state.product
		});
	}

	handleNameChange = (e, data) =>
	{
		const props = this.props, component = this, state = this.state;

		let product = _.cloneDeep(state.product);

		component.handleChange(e, data);

		if (!e) return;

		let name  = e.target.name;
		let value = e.target.value;

		let type = name.split('][')[1].split(']').join('');

		let index = name.slice(name.indexOf('[') + 1, name.indexOf(']'));

		index = Number(index);

		product.cart_names = product.cart_names || [];

		product.cart_names[index] = product.cart_names[index] || { };

		if (type === 'date')
		{
			product.cart_names[index].date = value;
		}
		else if (type === 'firstname')
		{
			product.cart_names[index].firstname = value;
		}
		else if (type === 'name')
		{
			product.cart_names[index].name = value;
		}

		component.setState(
		{
			product: product,
			nominative_info: false
		});
	}

	validateNames = () =>
	{
		const props = this.props, component = this, state = this.state;

		let product = _.cloneDeep(state.product);

		if (!isTrue(product.cart_price.nominative))
		{
			return false;
		}

		let is_valid = true;

		Object.keys(state.form_data)
		.filter(function (name)
		{
			if (name.indexOf('cart_names') === -1) return false;

		// filter out unwanted data
			if (name.indexOf('[name]') === -1 && name.indexOf('[date]') === -1 &&
				name.indexOf('[firstname]') === -1)
			{
				return false;
			}

			return true;
		})
		.forEach(function (name)
		{
			let value = state.form_data[name];

			let type = name.split('][')[1].split(']').join('');

			if (!value || value.trim().length <= 1)
			{
				is_valid = false;

				state.status_messages[name] = state.status_messages[name] || { };

				if (type === 'date')
				{
					state.status_messages[name].error = 'Date requise';
				}
				else if (type === 'firstname')
				{
					state.status_messages[name].error = 'Prénom requis';
				}
				else
				{
					state.status_messages[name].error = 'Nom requis';
				}
			}
		});

		component.setState(
		{
			status_messages: state.status_messages
		});

		return is_valid;
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			loading: false,
			form_data: { },
			status_messages: { },
			product: { cart_price: { } },
			nominative_info: true,
			source: ''
		});
	}

	changeQty = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		let product = _.cloneDeep(state.product);

		if (!product.cart_qty) product.cart_qty = 0;

		if (e === 'less')
		{
			product.cart_qty--;
		}
		else if (e === 'more')
		{
			product.cart_qty++;
		}
		else if (e && e.target)
		{
			let qty = numeral(safeNumeral(e.target.value));

			if (product)
			{
				product.cart_qty = qty.format('0');
			}
		}

		if (Number(product.cart_qty) <= 0)
		{
			product.cart_qty = 1;
		}

		if (isTrue(product.cart_price.nominative))
		{
			product.cart_names = product.cart_names || [];

			while (product.cart_names.length !== product.cart_qty)
			{
				if (product.cart_names.length < product.cart_qty)
				{
					product.cart_names.push('');
				}
				else
				{
					let pattern = 'cart_names[' + product.cart_names.length-1 + ']';

					delete state.form_data[pattern + '[firstname]'];
					delete state.form_data[pattern + '[name]'];
					delete state.form_data[pattern + '[date]'];

					product.cart_names.pop();
				}
			}
		}

		component.setState(
		{
			product: product,
			form_data: state.form_data
		});
	}

	open = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		let product = _.cloneDeep(data.product);

		product.cart_qty = 1;

		let store_product = app.state.cart.find(function (cart_item)
		{
			if (cart_item.id !== product.id) return false;

			return cart_item.cart_price.ref === product.cart_price.ref;
		});

		if (typeof store_product !== 'undefined')
		{
			product.cart_qty = store_product.cart_qty

			if (app.state.session.permissions.title === 'EC')
			{
				product.EC_order_as = store_product.EC_order_as || '';
			}
		}

		if (typeof store_product !== 'undefined')
		{
			product.cart_onlineTicket = store_product.cart_onlineTicket;
		}
		else if (isTrue(product.cart_price.online_ticket))
		{
			product.cart_onlineTicket = true;
		}
		else if (!isTrue(product.cart_price.online_ticket))
		{
			product.cart_onlineTicket = false;
		}

	/**
	 * Add product to cart if the price is not nominative (we need name before)
	 **/
		if (isTrue(product.cart_price.nominative))
		{
			if (typeof store_product !== 'undefined')
			{
				product.cart_names = _.cloneDeep(store_product.cart_names || []);

				product.cart_names.forEach(function (data, index)
				{
					state.form_data['cart_names[' + index + '][date]'] = data.date;
					state.form_data['cart_names[' + index + '][name]'] = data.name;
					state.form_data['cart_names[' + index + '][firstname]'] = data.firstname;
				});
			}
			else
			{
				product.cart_names = [];
			}
		}

		component.setState(
		{
			open : true,
			error: undefined,
			product: product,
			form_data: state.form_data,
			source: data.source
		});
	}

	validate = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		let product = _.cloneDeep(state.product);

		if (isTrue(product.date_required) && !product.date_required_value)
		{
			return component.setState(
			{
				status_messages:
				{
					...state.status_messages,

					'date_required_value':
					{
						error: 'Requise'
					}
				}
			});
		}

		if (isTrue(product.cart_price.nominative) &&
			component.validateNames() !== true)
		{
			return;
		}

		const store_product = (app.state.cart || []).find(function (cart_item, i)
		{
			if (cart_item.id !== product.id) return false;

			if (cart_item.cart_price.ref === product.cart_price.ref)
			{
				app.state.cart[i] = product;

				return true;
			}
		});

		delete product.description;

		if (product._places)
		{
			product._places.forEach(function (place)
			{
				delete place.description;
			});
		}

		if (typeof store_product === 'undefined')
		{
			app.state.cart.push(product);
		}

		component.setState({ loading: true });

		qwest.post('/cart/update', { cart: app.state.cart })
		.then(function (xhr, response)
		{
			app.emit('cartChange');

			component.setState({ loading: false });

			component.handleClose(e, true);
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);

			component.setState({ loading: false, error: response.error });
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		const product = state.product || { };

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['secondary', 'bg-white'] } />
		)
		: undefined;

		let store_product = app.state.cart.find(function (cart_item, i)
		{
			if (cart_item.id !== product.id) return false;

			return (cart_item.cart_price.ref === product.cart_price.ref);
		});

	/**
	 * ----- GETTING PRODUCT OR ARTIST IMAGES ----- *
	 **/

		let product_img;

		if (product.images && product.images[0] && product.images[0].url)
		{
			product_img =
			(
				<Image className="cart-modal__product-img"
					alt={ product.name } src={ product.images[0].url }
				/>
			);
		}

		if (!product_img && product._artist && product._artist.images &&
			product._artist.images[0] && product._artist.images[0].url)
		{
			product_img =
			(
				<Image className="cart-modal__product-img"
					alt={ product._artist.name }
					src={ product._artist.images[0].url }
				/>
			);
		}

		let position = product.cart_price?._position;

	/**
	 * Getting position
	 **/
		if (position)
		{
			position =
			(
				<div className="cart-modal__infos position">
					<strong>Placement&nbsp;:</strong>
					{ position.label }
				</div>
			);
		}

		let age = product.cart_price?._age;

		if (age)
		{
			age =
			(
				<div className="cart-modal__infos date">
					<strong>Age&nbsp;:</strong>
					{ age.label }
				</div>
			);
		}

		let price_date = product.cart_price?.date;

		if (price_date)
		{
			price_date =
			(
				<div className="cart-modal__infos date">
					<strong>Date&nbsp;:</strong>
					{ moment(price_date).format('ddd DD MMM YYYY - HH[h]mm') }
				</div>
			);
		}

		let ticket_type = product.cart_price?._ticket_type;

		if (ticket_type)
		{
			ticket_type =
			(
				<div className="cart-modal__infos ticket_type">
					<strong>Type&nbsp;:</strong>
					{ ticket_type.label }
				</div>
			);
		}

		let places;

		if (product._places && product._places.length)
		{
			places = product._places.map(function (place, number)
			{
				let city = (place.address.city.slice(0, 1).toUpperCase() +
					place.address.city.slice(1).toLowerCase());

				if (product._places.length > 1)
				{
					if (number > 0) return ', ' + city;

					return city;
				}
				else
				{
					return place.name || city;
				}
			});

			places =
			(
				<div className="cart-modal__infos places">
					<svg className="o-svg-icon o-svg-icon--tracker cart-modal__infos-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
					</svg>
					{ places }
				</div>
			);
		}

		let qty =
		(
			<div className="c-qty u-margin-top-10">
				<button type="button" className="c-qty__less"
					onClick={ e => component.changeQty('less') }>
					{ '-' }
				</button>

				<input type="text" className="c-qty__input"
					value={ product.cart_qty }
					onChange={ e =>component.changeQty(e) }
				/>

				<button type="button" className="c-qty__more"
					onClick={ e => component.changeQty('more') }>
					{ '+' }
				</button>
			</div>
		);

		let comment;

		if ((product.cart_price?.comment || '').trim().length > 0)
		{
			comment =
			(
				<div className="c-message c-message--orange">
					<div className="c-message__content" dangerouslySetInnerHTML={
						{ __html: product.cart_price.comment } }
					/>
				</div>
			);
		}

		let validity_date, date_max;

		if (product.cart_price?.validity_date)
		{
			date_max = moment(product.cart_price.validity_date).format('YYYY-MM-DD');

			validity_date =
			(
				<div className="cart-modal__infos date">
					<strong>Valide jusqu'au&nbsp;:</strong>
					&nbsp;
					{
						moment(product.cart_price.validity_date)
						.format('DD/MM/YYYY')
					}
				</div>
			);
		}

		const date_required = isTrue(product.date_required) ?
		(
			<div className="cart-modal__infos date">
				<FormElement type="date" name="date_required_value"
					min={ moment().format('YYYY-MM-DD') }
					max={ date_max }
					data={
						{ date_required_value: state.product?.date_required_value }
					}
					label="1er Jour de visite"
					onChange={ component.handleRequiredDateChange }
					status={ state.status_messages }
				/>
			</div>
		)
		: undefined;

		let success_message, order_as, names = [];

		if (isTrue(product.cart_price?.nominative))
		{
			for (let i = 0; i < product.cart_qty; i++)
			{
				let input =
				(
					<div className="cart-modal__names" key={ i }>

						<FormElement type="text"
							name={ 'cart_names[' + i + '][firstname]' }
							data={ state.form_data } label="Prénom"
							onChange={ component.handleNameChange }
							status={ state.status_messages }
						/>

						<FormElement type="text" name={ 'cart_names[' + i + '][name]' }
							data={ state.form_data } label="Nom"
							onChange={ component.handleNameChange }
							status={ state.status_messages }
						/>

						<FormElement type="date" name={ 'cart_names[' + i + '][date]' }
							data={ state.form_data } label="Date de naissance"
							onChange={ component.handleNameChange }
							status={ state.status_messages }
						/>

					</div>
				);

				names.push(input);
			}

			names =
			(
				<div className="cart-modal__names">
					{ names }
				</div>
			);

			if (state.nominative_info && state.source === 'productPage')
			{
				success_message =
				(
					<div className={ bemit('c-message', ['red']) }>
						<div className="c-message__content">
							Ces billets sont nominatifs, vous devez renseigner un nom et un prénom pour chacun d'eux.
						</div>
					</div>
				);
			}
			else
			{
				success_message = undefined;
			}
		}
		else if (app.state.session.permissions.title === 'EC')
		{
			order_as =
			(
				<div className={ bemit('c-form-element', ['text']) }>

					<label className={ bemit('c-form-label', [props.type]) }
						htmlFor="cart-modal-order-as">
						Au nom de (optionnel)
					</label>

					<input className="c-form__input" name="order_as"
						onChange={ component.handleOrderAsChange }
						type="text" value={ state.product?.EC_order_as || '' }
						id="cart-modal-order-as" spellCheck={ false }
					/>

				</div>
			);
		}

		let online_ticket_choice;

		if (isTrue(product.cart_price?.online_ticket))
		{
			if (product.hasOwnProperty('cart_onlineTicket'))
			{
				online_ticket_choice =
				(
					<FormElement type="checkbox" name="online_ticket"
						onChange={ component.handleOnlineShippingChange }
						data={ state.form_data }
						status={ state.status_messages }
						defaultValue={ product.cart_onlineTicket }
						label="Format électronique"
						readOnly={ product.online_type === 'instant' }
					/>
				);
			}
		}

		let output =
		(
			<Modal className="o-modal o-modal--front" open={ component.state.open }
				onClose={ component.handleClose }
				hide_close={ true }
				title={ typeof store_product === 'undefined'
					? 'Ajouter au panier'
					: 'Mise à jour du panier'
				}>

				<div className="cart-modal">

					<div className="cart-modal__product">

						<div className="cart-modal__product-infos">

							{ price_date }
							{ date_required }
							{ ticket_type }
							{ age }
							{ position }
							{ validity_date }
							{ places }
							{ qty }
							{ comment }

						</div>

					</div>

					<div className="cart-modal__content">

						{ success_message }

						{ names }

						{ order_as }

						{ online_ticket_choice }

						{
							online_ticket_choice && product.online_type !== 'instant' ?
							(
								<div className={ bemit('c-message', ['blue']) }>
									<div className="c-message__content">
										Délivré uniquement entre 8h30 et 17h30 du lundi au vendredi, hors jours fériés.
									</div>
								</div>
							)
							: undefined
						}

						{
							state.error ?
							(
								<div className="u-full-width">
									{ getFormStatus({ error: state.error }) }
								</div>
							)
							: undefined
						}

					</div>

				</div>

				<div className="c-dialog__buttons">

					<button className="c-btn c-dialog__danger u-margin-right-10"
						onClick={ component.validate }>
						{
							typeof store_product === 'undefined'
							? 'Ajouter'
							: 'Mettre à jour'
						}
					</button>

					<button className="c-btn c-dialog__cancel u-margin-right-0"
						onClick={ component.handleClose }>
						Fermer
					</button>

				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
